import { cn, Icon } from '@mntn/ui-components'
import { Button } from '@/components/shared'

interface ToggleViewProps {
  view: 'list' | 'grid'
  setView: (view: 'list' | 'grid') => void
  className?: string
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const ToggleView: React.FC<ToggleViewProps> = ({ view, setView, className }) => {
  return (
    <div className={cn('flex', className)}>
      <Button
        size="small"
        aria-label="List view"
        variant={view === 'list' ? 'active' : 'inactive'}
        className="px-6 py-4 rounded-xs flex items-center gap-2 h-auto"
        onClick={() => setView('list')}
      >
        <Icon name="List" className="size-5 text-header-inverse" />
      </Button>
      <Button
        size="small"
        aria-label="Grid view"
        variant={view === 'grid' ? 'active' : 'inactive'}
        className="px-6 py-4 rounded-xs flex items-center gap-2 h-auto"
        onClick={() => setView('grid')}
      >
        <Icon name="LayoutGrid" className="size-5 text-header-inverse" />
      </Button>
    </div>
  )
}
